import React from 'react';
import { Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useMeta } from '../contexts/MetaContext';

const HomePage = () => {
  const navigate = useNavigate();
  const { metaData } = useMeta();

  React.useEffect(() => {
    document.title = `${metaData.storeName} - Home`;
  }, [metaData.storeName]);

  const handleShopNow = () => {
    navigate('/search');
  };

  return (
    <Box sx={{ textAlign: 'center', py: 8 }}>
      <Typography variant="h2" component="h1" gutterBottom>
        {metaData.texts.homePage.title}
      </Typography>
      <Typography variant="h5" component="h2" gutterBottom>
        {metaData.texts.homePage.subtitle}
      </Typography>
      <Button 
        variant="contained" 
        color="primary" 
        size="large" 
        sx={{ mt: 4 }}
        onClick={handleShopNow}
      >
        {metaData.texts.homePage.shopNowButton}
      </Button>
    </Box>
  );
};

export default HomePage;